<template>
	<div class="container">
		<h1>{{ msg.title }}</h1>
		<div v-html="msg.content"></div>
	</div>
</template>

<script>
export default {
	props: {
		msg: Object,
	},
};
</script>

<style scoped>
h1 {
	font-size: 2rem;
	margin-bottom: 0.5rem;
}
.container {
	margin: auto;
	padding: 2.5%;
	width: 500px;
	max-width: 80%;
	border: 1px solid black;
	border-radius: 25px;
}
</style>
